// period-retoure.js — Retouren-Wizard for period.ch
// Teil des Retouren-Systems (Projects/Retouren-System/, eigenes Repo seit 03.08.2026).
// Backend/Cron liegen dort — diese Datei bleibt aus Shopify-Pfadzwang in Period4.0,
// siehe Retouren-System/docs/THEME_DATEIEN.md vor jeder Änderung.
// All API calls go through this base URL (update after Railway deploy)
const API_BASE_URL = 'https://period-retoure-production.up.railway.app';

(function () {
  'use strict';

  // ─── Constants ────────────────────────────────────────────────────────────

  const BUNDLE_HANDLES = [
    // Handle-Umbenennung ~Juli 2026: aus '…-starter-bundle' wurde '…-premium-bundle'.
    // Beide bleiben stehen — Altbestellungen tragen weiterhin den alten Handle.
    'active-cycle-starter-bundle',
    'active-cycle-premium-bundle',
    'vulva-balance-bundle',
    'skin-repair-glow-bundle',
    'deep-pleasure-ritual-set',
  ];

  const EDU_LINKS = {
    'disk':                        '/pages/disk',
    'acpb':                        '/pages/disk',
    'active-cycle-starter-bundle': '/pages/disk',
    'active-cycle-premium-bundle': '/pages/disk',
    'lila-lippen':                 '/pages/edukation-vulva',
    'vbb':                         '/pages/edukation-vulva',
    'vulva-balance-bundle':        '/pages/edukation-vulva',
    'oranger-samt':                '/pages/edukation-skin',
    'skin-repair-glow-bundle':     '/pages/edukation-skin',
    'srgb':                        '/pages/edukation-skin',
    'goldene-lust':                '/pages/edukation-lust',
    'dprs':                        '/pages/edukation-lust',
    'deep-pleasure-ritual-set':    '/pages/edukation-lust',
  };

  const REASONS_MAP = {
    disk: [
      'Grösse passt nicht',
      'Einsetzen oder Entfernen schwierig',
      'Läuft trotzdem aus',
      'Wirkung/Komfort nicht wie erwartet',
      'Medizinischer Grund',
      'Versehentlich bestellt',
      'Anderes',
    ],
    oil: [
      'Wirkung nicht spürbar',
      'Hautreaktion oder Unverträglichkeit',
      'Geruch oder Konsistenz nicht passend',
      'Nicht wie beschrieben',
      'Versehentlich bestellt',
      'Anderes',
    ],
    supplement: [
      'Keine spürbare Wirkung',
      'Nebenwirkungen oder Unverträglichkeit',
      'Geschmack/Einnahme nicht passend',
      'Versehentlich bestellt',
      'Anderes',
    ],
    default: [
      'Produkt hat nicht gepasst',
      'Qualität nicht wie erwartet',
      'Versehentlich bestellt',
      'Anderes',
    ],
  };

  // 'blaue-tranen' ohne 'e' ist die echte Admin-Schreibweise (blaue-tranen-entspannungsol);
  // 'blaue-traenen' bleibt als Altlast stehen, kostet nichts und deckt Altbestellungen ab.
  const OIL_HANDLES = ['lila-lippen', 'oranger-samt', 'goldene-lust', 'blaue-tranen', 'blaue-traenen'];
  const SUPPLEMENT_HANDLES = ['pinke-perlen', 'rote-balance', 'mega-magnesium', 'mind-crown', 'pontams'];
  const DISK_HANDLES = ['disk', 'period-disk', 'active-cycle-starter-bundle', 'active-cycle-premium-bundle'];

  // ─── State ────────────────────────────────────────────────────────────────

  const state = {
    activeDiv: 1,
    orderNumber: '',
    customerEmail: '',
    order: null,
    perProduct: [],   // [{ product, returnType, reason, photoBase64 }]
    currentIndex: 0,  // welches Produkt gerade Grund/Foto bekommt
  };

  // ─── DOM helpers ──────────────────────────────────────────────────────────

  const $ = (id) => document.getElementById(id);
  const show = (el, as = 'block') => { el.hidden = false; el.style.display = as; };
  const hide = (el) => { el.hidden = true; el.style.display = 'none'; };
  const setError = (el, msg) => { el.textContent = msg; show(el); };
  const clearError = (el) => { el.textContent = ''; hide(el); };

  function setLoading(btn, loading) {
    const text = btn.querySelector('.rf__btn-text');
    const loader = btn.querySelector('.rf__btn-loader');
    btn.disabled = loading;
    if (text) text.hidden = loading;
    if (loader) loader.hidden = !loading;
  }

  // Preis marktabhängig formatieren — Währung kommt aus der Bestellung (validate-order),
  // nie hart 'CHF'. EUR (period.de) → deutsches Format mit Komma; CHF → Schweizer Format.
  function formatMoney(amount, currency) {
    const num = parseFloat(amount);
    if (isNaN(num)) return '';
    const cur = (currency || 'CHF').toUpperCase();
    try {
      return new Intl.NumberFormat(cur === 'EUR' ? 'de-DE' : 'de-CH', {
        style: 'currency', currency: cur,
      }).format(num);
    } catch (e) {
      return cur + ' ' + num.toFixed(2);
    }
  }

  // ─── Progress bar ─────────────────────────────────────────────────────────
  // Dynamische Gesamtzahl: 5 + 2×Anzahl Produkte (bei 1 Produkt = 7).

  function updateProgress() {
    const n = Math.max(state.perProduct.length, 1);
    const total = 5 + 2 * n;
    let pos = 1;
    switch (state.activeDiv) {
      case 1: pos = 1; break;
      case 2: pos = 2; break;
      case 3: pos = 3; break;
      case 4: pos = 4 + 2 * state.currentIndex; break;
      case 5: pos = 5 + 2 * state.currentIndex; break;
      case 6: pos = 4 + 2 * n; break;
      case 7: pos = 5 + 2 * n; break;
    }
    const bar = $('rf-progress-bar');
    const label = $('rf-progress-label');
    const pct = Math.round((pos / total) * 100);
    bar.style.width = pct + '%';
    bar.setAttribute('aria-valuenow', pct);
    label.textContent = 'Schritt ' + pos + ' von ' + total;
  }

  function showStep(n) {
    document.querySelectorAll('.rf__step').forEach((el) => hide(el));
    const step = $('rf-step-' + n);
    if (step) show(step);
    state.activeDiv = n;
    updateProgress();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  // ─── Helpers: Produkt-Klassifizierung ──────────────────────────────────────

  // Gibt die Edu-URL zurück, oder null wenn keine existiert (z.B. Supplements)
  function eduUrlForHandle(handle) {
    const h = (handle || '').toLowerCase();
    for (const key of Object.keys(EDU_LINKS)) {
      if (h.includes(key)) return EDU_LINKS[key];
    }
    return null;
  }

  // Der Rückgabetyp wird seit 03.08.2026 SERVERSEITIG entschieden (backend/lib/
  // return-policy.js) und von /api/validate-order mitgeliefert. Die lokale Rechnung
  // bleibt nur als Fallback, falls das Feld fehlt — sie darf nie wieder allein
  // massgeblich sein, sonst ist der Typ per Request manipulierbar.
  function returnTypeForProduct(item) {
    if (item.returnType === 'green' || item.returnType === 'physical') {
      return item.returnType;
    }
    const handle = (item.product_handle || '').toLowerCase();
    const qty = item.quantity || 1;
    const totalCents = Math.round(parseFloat(item.price) * 100) * qty;
    const isBundle = BUNDLE_HANDLES.some((b) => handle.includes(b));
    return (isBundle || totalCents >= 5000) ? 'physical' : 'green';
  }

  function reasonsForHandle(handle) {
    const h = (handle || '').toLowerCase();
    if (DISK_HANDLES.some((d) => h.includes(d))) return REASONS_MAP.disk;
    if (OIL_HANDLES.some((d) => h.includes(d))) return REASONS_MAP.oil;
    if (SUPPLEMENT_HANDLES.some((d) => h.includes(d))) return REASONS_MAP.supplement;
    return REASONS_MAP.default;
  }

  // ─── Step 1 — Order validation ────────────────────────────────────────────

  function initStep1() {
    const orderInput = $('rf-order-number');
    const emailField = $('rf-email-field');
    const emailInput = $('rf-customer-email');
    const nextBtn = $('rf-step1-next');
    const errorEl = $('rf-step1-error');

    orderInput.addEventListener('blur', () => {
      if (orderInput.value.trim().length > 2) {
        show(emailField);
        emailInput.focus();
      }
    });

    nextBtn.addEventListener('click', async () => {
      clearError(errorEl);
      const orderNumber = orderInput.value.trim();
      const email = emailInput.value.trim();

      if (!orderNumber) { setError(errorEl, 'Bitte gib deine Bestellnummer ein.'); return; }
      if (!email) { setError(errorEl, 'Bitte gib deine E-Mail-Adresse ein.'); return; }

      setLoading(nextBtn, true);
      try {
        const res = await fetch(API_BASE_URL + '/api/validate-order', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ orderNumber, email }),
        });
        const data = await res.json();

        if (data.error === 'not_found') {
          setError(errorEl, 'Keine Bestellung mit dieser Nummer und E-Mail-Adresse gefunden.');
          return;
        }
        if (data.error === 'expired') {
          setError(errorEl, 'Diese Bestellung liegt mehr als 40 Tage zurück und kann leider nicht mehr retourniert werden.');
          return;
        }
        if (data.error === 'nothing_returnable') {
          setError(errorEl, 'Für diese Bestellung wurde bereits alles erstattet. Bei Fragen schreib uns an info@period.ch.');
          return;
        }
        if (data.error || !data.order) {
          setError(errorEl, 'Ein Fehler ist aufgetreten. Bitte versuche es erneut.');
          return;
        }

        state.orderNumber = orderNumber;
        state.customerEmail = email;
        state.order = data.order;
        renderProductList();
        showStep(2);
      } catch {
        setError(errorEl, 'Verbindungsfehler. Bitte versuche es erneut.');
      } finally {
        setLoading(nextBtn, false);
      }
    });
  }

  // ─── Step 2 — Product selection (Mehrfachauswahl) ──────────────────────────

  function renderProductList() {
    const container = $('rf-product-list');
    container.innerHTML = '';
    $('rf-order-name-display').textContent = state.order.name;

    const items = state.order.line_items || [];

    items.forEach((item, idx) => {
      const id = 'rf-product-' + idx;
      const priceFormatted = formatMoney(item.price, state.order.currency);

      const card = document.createElement('label');
      card.className = 'rf__product-card';
      card.setAttribute('for', id);

      const input = document.createElement('input');
      input.type = 'checkbox';
      input.name = 'product';
      input.id = id;
      input.value = idx;
      input.className = 'rf__product-radio';

      const info = document.createElement('div');
      info.className = 'rf__product-info';

      const title = document.createElement('span');
      title.className = 'rf__product-title';
      title.textContent = item.title;
      if (item.variant_title) {
        const variant = document.createElement('span');
        variant.className = 'rf__product-variant';
        variant.textContent = item.variant_title;
        title.appendChild(variant);
      }

      const meta = document.createElement('span');
      meta.className = 'rf__product-meta';
      meta.textContent = priceFormatted;
      if (item.quantity > 1) meta.textContent += ' · ' + item.quantity + '×';

      info.appendChild(title);
      info.appendChild(meta);

      if (item.quantity > 1) {
        const qtyNote = document.createElement('span');
        qtyNote.className = 'rf__product-qty-note';
        qtyNote.textContent =
          'Du hast ' + item.quantity + '× dieses Produkt bestellt — alle ' + item.quantity + ' Einheiten müssen retourniert werden.';
        info.appendChild(qtyNote);
      }

      card.appendChild(input);
      card.appendChild(info);
      container.appendChild(card);

      input.addEventListener('change', () => {
        card.classList.toggle('is-selected', input.checked);
      });
    });

    // Bei nur einem Artikel automatisch anwählen
    if (items.length === 1) {
      const cb = container.querySelector('input[type="checkbox"]');
      if (cb) {
        cb.checked = true;
        container.querySelector('.rf__product-card').classList.add('is-selected');
      }
    }
  }

  function initStep2() {
    $('rf-step2-back').addEventListener('click', () => showStep(1));
    $('rf-step2-next').addEventListener('click', () => {
      const checked = Array.prototype.slice.call(
        document.querySelectorAll('input[name="product"]:checked')
      );
      const errorEl = $('rf-step2-error');
      clearError(errorEl);

      if (checked.length === 0) {
        setError(errorEl, 'Bitte wähle mindestens ein Produkt aus.');
        return;
      }

      state.perProduct = checked.map((cb) => {
        const item = state.order.line_items[parseInt(cb.value, 10)];
        return { product: item, returnType: returnTypeForProduct(item), reason: '', photoBase64: null };
      });
      state.currentIndex = 0;
      renderEduLinks();
      showStep(3);
    });
  }

  // ─── Step 3 — Retention ───────────────────────────────────────────────────

  function renderEduLinks() {
    const container = $('rf-edu-links');
    container.innerHTML = '';
    const multiple = state.perProduct.length > 1;

    state.perProduct.forEach((pp) => {
      const url = eduUrlForHandle(pp.product.product_handle);

      if (url) {
        // Produkt mit Edu-Seite → Button-Link
        const a = document.createElement('a');
        a.className = 'rf__edu-link';
        a.href = url;
        a.target = '_blank';
        a.rel = 'noopener';
        a.textContent = multiple
          ? ('Ich bin offen für Tipps – ' + pp.product.title)
          : 'Ich bin offen für Tipps';
        container.appendChild(a);
      } else {
        // Kein Edu-Link (z.B. Supplements) → freundliche Textfrage
        const txt = document.createElement('p');
        txt.className = 'rf__body rf__retention-note';
        txt.textContent = multiple
          ? (pp.product.title + ': Supplements wirken oft subtiler als erwartet — und selten sofort. Hast du es schon mindestens 4–6 Wochen regelmässig eingenommen?')
          : 'Supplements wirken oft subtiler als erwartet — und selten sofort. Hast du es schon mindestens 4–6 Wochen regelmässig eingenommen?';
        container.appendChild(txt);
      }
    });
  }

  function initStep3() {
    $('rf-step3-back').addEventListener('click', () => showStep(2));
    $('rf-step3-next').addEventListener('click', () => {
      state.currentIndex = 0;
      enterReasonStep();
    });
  }

  // ─── Step 4 — Reason (pro Produkt) ─────────────────────────────────────────

  function enterReasonStep() {
    const pp = state.perProduct[state.currentIndex];
    const container = $('rf-reason-list');
    const otherField = $('rf-reason-other-field');
    const otherText = $('rf-reason-other-text');
    container.innerHTML = '';
    hide(otherField);

    // Produkt-Label nur bei mehreren Produkten
    const label = $('rf-step4-product');
    if (state.perProduct.length > 1) {
      label.textContent = pp.product.title + ' (' + (state.currentIndex + 1) + '/' + state.perProduct.length + ')';
      show(label);
    } else {
      label.textContent = '';
      hide(label);
    }

    const reasons = reasonsForHandle(pp.product.product_handle);
    // Gespeicherte Gründe: können mehrere sein, getrennt durch ' / '
    const savedReasons = pp.reason ? pp.reason.split(' / ').map((r) => r.trim()) : [];
    const savedOtherText = savedReasons
      .filter((r) => r.startsWith('Anderes:'))
      .map((r) => r.replace(/^Anderes:\s*/, ''))
      .join('');
    const savedPlainReasons = savedReasons.map((r) => r.startsWith('Anderes:') ? 'Anderes' : r);

    reasons.forEach((reason, idx) => {
      const id = 'rf-reason-' + idx;
      const card = document.createElement('label');
      card.className = 'rf__reason-card';
      card.setAttribute('for', id);

      const checkbox = document.createElement('input');
      checkbox.type = 'checkbox';
      checkbox.name = 'reason';
      checkbox.id = id;
      checkbox.value = reason;
      checkbox.className = 'rf__reason-radio';

      const text = document.createElement('span');
      text.textContent = reason;
      card.appendChild(checkbox);
      card.appendChild(text);
      container.appendChild(card);

      if (savedPlainReasons.includes(reason)) {
        checkbox.checked = true;
        card.classList.add('is-selected');
        if (reason === 'Anderes') show(otherField);
      }

      checkbox.addEventListener('change', () => {
        card.classList.toggle('is-selected', checkbox.checked);
        const anyOther = !!container.querySelector('input[value="Anderes"]:checked');
        if (anyOther) { show(otherField); otherText.focus(); }
        else hide(otherField);
      });
    });

    // gespeicherten Freitext wiederherstellen
    otherText.value = savedOtherText;

    showStep(4);
  }

  function initStep4() {
    $('rf-step4-back').addEventListener('click', () => {
      if (state.currentIndex === 0) {
        showStep(3);
      } else {
        state.currentIndex -= 1;
        enterPhotoStep(); // zurück zum Foto des vorherigen Produkts
      }
    });

    $('rf-step4-next').addEventListener('click', () => {
      const checked = Array.prototype.slice.call(
        document.querySelectorAll('input[name="reason"]:checked')
      );
      const errorEl = $('rf-step4-error');
      clearError(errorEl);

      if (checked.length === 0) { setError(errorEl, 'Bitte wähle mindestens einen Grund aus.'); return; }

      const hasOther = checked.some((c) => c.value === 'Anderes');
      if (hasOther) {
        const txt = $('rf-reason-other-text').value.trim();
        if (!txt) { setError(errorEl, 'Bitte beschreibe den Grund.'); return; }
      }

      const reasons = checked.map((c) => {
        if (c.value === 'Anderes') return 'Anderes: ' + $('rf-reason-other-text').value.trim();
        return c.value;
      });
      state.perProduct[state.currentIndex].reason = reasons.join(' / ');
      enterPhotoStep();
    });
  }

  // ─── Bildverkleinerung ─────────────────────────────────────────────────────
  //
  // Seit 03.08.2026: Das Foto wird im Browser auf max. 1600 px verkleinert und als
  // JPEG neu kodiert, bevor es hochgeladen wird. Zwei Gruende:
  //   1. Handyfotos sind 4–10 MB; als Base64 wurden daraus 13 MB pro Anfrage.
  //   2. Das Neu-Zeichnen auf ein Canvas verwirft saemtliche EXIF-Daten — also auch
  //      GPS-Koordinaten, Aufnahmezeit und Geraetekennung, die vorher unveraendert
  //      beim Mailversand und im Sammelpostfach landeten.
  // Typisches Ergebnis: unter 500 KB.

  const MAX_EDGE = 1600;
  const JPEG_QUALITY = 0.82;

  function shrinkImage(file, done) {
    if (!window.FileReader || !document.createElement('canvas').getContext) {
      // Sehr alter Browser: unveraendert hochladen, der Server prueft ohnehin.
      const fallback = new FileReader();
      fallback.onload = (e) => done(e.target.result, null);
      fallback.onerror = () => done(null, 'read');
      fallback.readAsDataURL(file);
      return;
    }

    const reader = new FileReader();
    reader.onerror = () => done(null, 'read');
    reader.onload = (e) => {
      const img = new Image();
      img.onerror = () => done(null, 'decode');
      img.onload = () => {
        try {
          let { width, height } = img;
          if (!width || !height) return done(null, 'decode');

          const scale = Math.min(1, MAX_EDGE / Math.max(width, height));
          width = Math.round(width * scale);
          height = Math.round(height * scale);

          const canvas = document.createElement('canvas');
          canvas.width = width;
          canvas.height = height;
          const ctx = canvas.getContext('2d');
          // Weisser Grund, damit transparente PNGs im JPEG nicht schwarz werden.
          ctx.fillStyle = '#ffffff';
          ctx.fillRect(0, 0, width, height);
          ctx.drawImage(img, 0, 0, width, height);

          const out = canvas.toDataURL('image/jpeg', JPEG_QUALITY);
          if (!out || out.indexOf('data:image/jpeg') !== 0) return done(null, 'encode');
          done(out, null);
        } catch (err) {
          done(null, 'canvas');
        }
      };
      img.src = e.target.result;
    };
    reader.readAsDataURL(file);
  }

  // ─── Step 5 — Photo (pro Produkt) ──────────────────────────────────────────

  function enterPhotoStep() {
    const pp = state.perProduct[state.currentIndex];
    const input = $('rf-photo-input');
    const nextBtn = $('rf-step5-next');
    const previewWrap = $('rf-photo-preview');
    const previewImg = $('rf-preview-img');
    const uploadArea = $('rf-upload-area');
    clearError($('rf-step5-error'));

    const label = $('rf-step5-product');
    if (state.perProduct.length > 1) {
      label.textContent = pp.product.title + ' (' + (state.currentIndex + 1) + '/' + state.perProduct.length + ')';
      show(label);
    } else {
      label.textContent = '';
      hide(label);
    }

    input.value = '';
    if (pp.photoBase64) {
      previewImg.src = pp.photoBase64;
      show(previewWrap);
      hide(uploadArea);
      nextBtn.disabled = false;
    } else {
      hide(previewWrap);
      show(uploadArea);
      nextBtn.disabled = true;
    }

    showStep(5);
  }

  function initStep5() {
    const input = $('rf-photo-input');
    const nextBtn = $('rf-step5-next');
    const previewWrap = $('rf-photo-preview');
    const previewImg = $('rf-preview-img');
    const uploadArea = $('rf-upload-area');
    const replaceBtn = $('rf-photo-replace');
    const errorEl = $('rf-step5-error');

    input.addEventListener('change', () => {
      const file = input.files[0];
      if (!file) return;
      clearError(errorEl);

      if (file.size > 10 * 1024 * 1024) {
        setError(errorEl, 'Das Foto darf maximal 10 MB gross sein.');
        input.value = '';
        return;
      }

      setError(errorEl, '');
      hide(errorEl);
      nextBtn.disabled = true;

      shrinkImage(file, function (dataUrl, err) {
        if (err || !dataUrl) {
          setError(errorEl, 'Dieses Bild konnten wir nicht verarbeiten. Bitte versuche ein anderes Foto.');
          input.value = '';
          return;
        }
        state.perProduct[state.currentIndex].photoBase64 = dataUrl;
        previewImg.src = dataUrl;
        show(previewWrap);
        hide(uploadArea);
        nextBtn.disabled = false;
      });
    });

    replaceBtn.addEventListener('click', () => {
      state.perProduct[state.currentIndex].photoBase64 = null;
      hide(previewWrap);
      show(uploadArea);
      input.value = '';
      nextBtn.disabled = true;
    });

    $('rf-step5-back').addEventListener('click', () => enterReasonStep());

    nextBtn.addEventListener('click', () => {
      if (!state.perProduct[state.currentIndex].photoBase64) return;
      if (state.currentIndex < state.perProduct.length - 1) {
        state.currentIndex += 1;
        enterReasonStep();
      } else {
        buildSummary();
        showStep(6);
      }
    });
  }

  // ─── Step 6 — Summary & submit ─────────────────────────────────────────────

  function buildSummary() {
    $('rf-sum-order').textContent = state.orderNumber;

    const itemsWrap = $('rf-summary-items');
    itemsWrap.innerHTML = '';
    let anyBundle = false;

    state.perProduct.forEach((pp) => {
      const handle = (pp.product.product_handle || '').toLowerCase();
      if (BUNDLE_HANDLES.some((b) => handle.includes(b))) anyBundle = true;

      let name = pp.product.title;
      if (pp.product.quantity > 1) name += ' (' + pp.product.quantity + '×)';

      const row = document.createElement('div');
      row.className = 'rf__summary-row';
      const label = document.createElement('span');
      label.className = 'rf__summary-label';
      label.textContent = name;
      const value = document.createElement('span');
      value.className = 'rf__summary-value';
      value.textContent = pp.reason;
      row.appendChild(label);
      row.appendChild(value);
      itemsWrap.appendChild(row);
    });

    const bundleNotice = $('rf-bundle-notice');
    if (anyBundle) show(bundleNotice); else hide(bundleNotice);
  }

  function initStep6() {
    $('rf-step6-back').addEventListener('click', () => {
      state.currentIndex = state.perProduct.length - 1;
      enterPhotoStep();
    });

    $('rf-step6-submit').addEventListener('click', async () => {
      const submitBtn = $('rf-step6-submit');
      const errorEl = $('rf-step6-error');
      clearError(errorEl);
      setLoading(submitBtn, true);

      try {
        const payload = {
          orderNumber: state.orderNumber,
          customerEmail: state.customerEmail,
          orderId: state.order ? state.order.id : null,
          currency: state.order ? state.order.currency : 'CHF',
          items: state.perProduct.map((pp) => ({
            lineItemId: pp.product.id || null,
            productHandle: pp.product.product_handle || '',
            productTitle: pp.product.title,
            productQuantity: pp.product.quantity || 1,
            unitPrice: pp.product.price,
            returnReason: pp.reason,
            photoBase64: pp.photoBase64,
            returnType: pp.returnType,
          })),
        };

        const res = await fetch(API_BASE_URL + '/api/submit-return', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
        });
        const data = await res.json();

        if (!data.success) {
          if (data.error === 'expired') {
            setError(errorEl, 'Diese Bestellung liegt mehr als 40 Tage zurück und kann leider nicht mehr retourniert werden.');
          } else if (data.error === 'item_already_refunded') {
            setError(errorEl, 'Für mindestens einen Artikel wurde bereits eine Erstattung verbucht. Bitte lade die Seite neu.');
          } else if (data.error === 'not_found') {
            setError(errorEl, 'Wir konnten die Bestellung nicht mehr zuordnen. Bitte starte noch einmal von vorn.');
          } else {
            setError(errorEl, 'Beim Einreichen ist ein Fehler aufgetreten. Bitte versuche es erneut oder schreib uns an info@period.ch.');
          }
          return;
        }

        // Der Server entscheidet über den Rückgabetyp — seine Antwort gewinnt über
        // die lokale Vorschau, damit die Bestätigung nie etwas anderes verspricht
        // als das, was tatsächlich verarbeitet wird.
        if (Array.isArray(data.types)) {
          data.types.forEach(function (t) {
            const pp = state.perProduct.find(function (p) {
              return String(p.product.id) === String(t.lineItemId);
            });
            if (pp && (t.returnType === 'green' || t.returnType === 'physical')) {
              pp.returnType = t.returnType;
            }
          });
        }

        renderConfirmation();
        showStep(7);
      } catch {
        setError(errorEl, 'Verbindungsfehler. Bitte versuche es erneut.');
      } finally {
        setLoading(submitBtn, false);
      }
    });
  }

  // ─── Step 7 — Confirmation (gemischte Green/Physical-Ergebnisse) ────────────

  function joinTitles(list) {
    const names = list.map((p) => p.product.title);
    if (names.length === 1) return names[0];
    return names.slice(0, -1).join(', ') + ' und ' + names[names.length - 1];
  }

  function renderConfirmation() {
    const titleEl = $('rf-confirm-title');
    const bodyEl = $('rf-confirm-body');

    const greens = state.perProduct.filter((p) => p.returnType === 'green');
    const physicals = state.perProduct.filter((p) => p.returnType === 'physical');

    if (physicals.length === 0) {
      // Alles Green Return
      titleEl.textContent = greens.length > 1 ? 'Du darfst deine Produkte behalten.' : 'Du darfst dein Produkt behalten.';
      bodyEl.textContent =
        'Die Ressourcen für Versand, Prüfung und Wiederverwertung wären grösser als der Wert des Produkts. Bitte schenke es jemandem weiter oder entsorge es fachgerecht. Deine Erstattung wird innerhalb von 5 Werktagen zurückgebucht.';
    } else if (greens.length === 0) {
      // Alles physisch
      titleEl.textContent = 'Deine Retouren-Anfrage ist eingegangen.';
      bodyEl.textContent =
        'Du erhältst eine Bestätigung an ' + state.customerEmail + '. Bitte schicke die Produkte erst zurück, wenn du diese Bestätigung erhalten hast.';
    } else {
      // Gemischt
      titleEl.textContent = 'Deine Retouren-Anfrage ist eingegangen.';
      bodyEl.textContent =
        'Behalten darfst du: ' + joinTitles(greens) + '. Diese musst du nicht zurückschicken — die Erstattung wird innerhalb von 5 Werktagen zurückgebucht. ' +
        'Für ' + joinTitles(physicals) + ' erhältst du eine Bestätigung an ' + state.customerEmail + ' — bitte erst nach dieser Bestätigung zurückschicken.';
    }
  }

  // ─── Init ─────────────────────────────────────────────────────────────────

  function init() {
    if (!document.getElementById('retoure-funnel')) return;
    showStep(1);
    initStep1();
    initStep2();
    initStep3();
    initStep4();
    initStep5();
    initStep6();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
